import { useState } from "react";
import { Pencil, Plus, Power } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const CatRow = ({ c, onChange }) => {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState({ name: c.name, description: c.description || "" });
  const save = async (patch) => {
    try {
      await api.put(`/admin/categories/${c.category_id}`, { ...v, active: c.active, ...patch });
      setEdit(false);
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <li className={`rounded-2xl border border-[#E2E5DC] p-3 ${c.active ? "bg-white" : "bg-[#F4F5F0] opacity-70"}`} data-testid={`category-row-${c.category_id}`}>
      {edit ? (
        <div className="space-y-2">
          <Input value={v.name} onChange={(e) => setV({ ...v, name: e.target.value })} className="h-10" data-testid={`category-edit-name-${c.category_id}`} />
          <Input value={v.description} placeholder="Descrizione (aiuta l'AI)" onChange={(e) => setV({ ...v, description: e.target.value })} className="h-10" />
          <div className="flex gap-2">
            <Button size="sm" onClick={() => save({})} className="rounded-full bg-[#0F2D5E]" data-testid={`category-save-${c.category_id}`}>Salva</Button>
            <Button size="sm" variant="ghost" onClick={() => setEdit(false)}>Annulla</Button>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <div className="min-w-0 flex-1">
            <p className="font-semibold">{c.name} {!c.active && <span className="text-xs font-normal">(disattivata)</span>}</p>
            <p className="truncate text-xs text-[#75867E]">{c.description}</p>
          </div>
          <Button size="icon" variant="ghost" className="h-10 w-10" onClick={() => setEdit(true)} aria-label="Modifica" data-testid={`category-edit-${c.category_id}`}><Pencil className="h-4 w-4" /></Button>
          <Button size="icon" variant="ghost" className="h-10 w-10" onClick={() => save({ active: !c.active })} aria-label={c.active ? "Disattiva" : "Attiva"} data-testid={`category-toggle-${c.category_id}`}>
            <Power className={`h-4 w-4 ${c.active ? "text-[#C62828]" : "text-[#0F2D5E]"}`} />
          </Button>
        </div>
      )}
    </li>
  );
};

export const CategoryManager = ({ open, onOpenChange, categories, onChange }) => {
  const [name, setName] = useState("");
  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/admin/categories", { name, description: "" });
      setName("");
      toast.success("Tipologia aggiunta");
      onChange();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] w-[calc(100vw-1.5rem)] max-w-lg overflow-y-auto rounded-3xl bg-white p-5 sm:p-7" data-testid="category-manager-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Tipologie</DialogTitle></DialogHeader>
        <form onSubmit={add} className="flex gap-2">
          <Input placeholder="Nuova tipologia" value={name} onChange={(e) => setName(e.target.value)} className="h-11" data-testid="new-category-input" />
          <Button type="submit" className="h-11 rounded-full bg-[#0F2D5E]" data-testid="add-category-btn"><Plus className="h-4 w-4" /></Button>
        </form>
        <ul className="space-y-2">{categories.map((c) => <CatRow key={c.category_id} c={c} onChange={onChange} />)}</ul>
      </DialogContent>
    </Dialog>
  );
};
